<template>
  <div class="dialog-error">
    <h3 class="dialog-error__title">Ошибка</h3>
    <div class="dialog-error__content">
      <vita-icon name="big-cross"/>
      <p class="dialog-error__text">{{error}}</p>
      <div class="dialog-error__button">
        <vita-button @click="back()" type="small" data-qa="auth-error-button-back">Вернуться</vita-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import {useStore} from "vuex";

const store = useStore();

interface Props {
  error: string
}

defineProps<Props>()

const back = () => {
  store.commit('user/setError', '')
}

onMounted(() => {
  store.commit('user/setLoader', false)
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '../static/style/variables.scss' as *;

.dialog-error {
  padding: 20px 24px;
  width: 660px;
  text-align: center;
  background: $white;
  box-shadow: -1px 0px 12px 0px #00000026;
  border-radius: 3px;
  position: relative;
  border: 1px solid #E52E52;

  &__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    text-align: left;
    margin-bottom: 24px;
  }

  &__text {
    margin: 24px 0;
  }

  &__button {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
  }

  a {
    display: block;
    color: $blue;
    cursor: pointer;
  }
}
</style>
